module.exports = __webpack_public_path__ + "static/media/bird-flamingo1.b9b01b4a.aac";